import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import category_data from 'src/app/shared/data/category-data';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { ICategoryType } from 'src/app/shared/types/category-d-t';
import { ProductService } from 'src/app/service/product.service';

@Component({
  selector: 'app-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss'],
})
export class CategoryFilterComponent implements OnInit{
  //public categoryData: ICategoryType[] = category_data;
  public categoryData:any = null;
  public category: number = 0;
  public subcategory: string | null = null;

  constructor(
    private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute,
    public utilsService: UtilsService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.category = params['category'] ? Number(params['category']) : 0;
      this.subcategory = params['subcategory'] ? params['subcategory'] : null;
    });
  }

  ngOnInit() {
    this.getCategoryData();
  }

  getCategoryData(){
    this.productService.productCategorys().subscribe({
      next:(res:any) => {
        if(res.status){
          console.log(res.categories);
          this.categoryData = res.categories;
        }
      },
    })
  }

  public handleParentCategory(categoryValue: string): void {
    const currentQueryParams = this.route.snapshot.queryParams; // Get current query parameters
    const queryParams = {
      ...currentQueryParams, // Keep the existing query parameters
      category: this.utilsService.customConvertToURL(categoryValue),
    };
    this.router.navigate(['/shop'], { queryParams });
  }

  public handleSubCategory(subcategoryValue: string): void {
    const currentQueryParams = this.route.snapshot.queryParams; // Get current query parameters
    const queryParams = {
      ...currentQueryParams, // Keep the existing query parameters
      subcategory: this.utilsService.convertToURL(subcategoryValue),
    };
    this.router.navigate(['/shop'], { queryParams });
  }
}
